export enum ToastType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  CriticalError = 'critical-error',
  Info = 'info',
  ImportantInfo = 'important-info',
  NeutralInfo = 'neutral-info',
  White = 'white',
}

export enum ToastSize {
  XXS = 'xxs',
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
  XXL = 'xxl',
}

export enum ToastEmit {
  Close = 'close',
  LifeEnd = 'life-end',
}
